
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, ExclusionMotive, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class ExclusionMotiveListProvider implements Resolve<any> {
    exclusionMotive: ExclusionMotive[];
    exclusionMotiveEdit: ExclusionMotive;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.exclusionMotiveEdit = this.state?.currentExclusionMotive;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'name';
        }
        return new Promise((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    get(id: number): Observable<ExclusionMotive> {
        if (!id) {
            return null;
        }
        return this.gw.get('exclusionMotive/:id', { id: id });
    }

    get currentExclusionMotive(): ExclusionMotive {
        return this.exclusionMotiveEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('exclusionMotive/').subscribe((res: HttpResponse<any>) => {
                this.exclusionMotive = res.body;
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('exclusionMotive/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.exclusionMotive, res.body.content) && res.body.content.length > 0) {
                    this.exclusionMotive = res.body.content;
                    this.onDataChanged.next(this.exclusionMotive);
                }
                else {
                    this.exclusionMotive = res.body.content;
                };
                resolve(res);
            }, reject);
        });
    }

    getPageActiveTrue(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('exclusionMotive/search/simpleList', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.exclusionMotive, res.body.content) && res.body.content.length > 0) {
                    this.exclusionMotive = res.body.content;
                    this.onDataChanged.next(this.exclusionMotive);
                }
                else {
                    this.exclusionMotive = res.body.content;
                };
                resolve(res);
            }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

